import { KatapultElement, html } from '../../mixins/katapult-element.js';
import { KatapultEditorTemplate } from './katapult-editor-template.js';

import { PortalStyle } from './katapult-model-editor-style.js';

import { ColorTranslator } from 'colortranslator';

import '../paper-header/paper-header.js';
import '../katapult-elements/katapult-button.js';
import '../katapult-color-picker/katapult-color-picker-button.js';
import '../k-logic-editor/k-logic-editor.js';
import { CamelCase } from '../../modules/CamelCase.js';

customElements.define(
  'katapult-make-ready-notification-editor',
  class extends KatapultEditorTemplate {
    static get template() {
      return html`
        ${super.style} ${PortalStyle}
        <style>
          katapult-color-picker-button {
            flex-shrink: 0;
            margin: 0;
          }
          katapult-switcher {
            font-size: 10pt;
            --katapult-switcher-paper-cell: {
              padding: 4px 8px;
            };
          }
        </style>

        <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/attributes" data="{{otherAttributes}}">
        </katapult-firebase-worker>
        <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/files" data="{{files}}"> </katapult-firebase-worker>

        <katapult-color-picker-dialog save-button-text="Select"></katapult-color-picker-dialog>

        <paper-table class="settings-table">
          <!-- No Cost Causer -->
          <paper-row>
            <paper-cell icon>
              <katapult-icon icon="attach_money"></katapult-icon>
            </paper-cell>
            <paper-cell shrink>Include Cost Causer</paper-cell>
            <paper-cell icon>
              <paper-checkbox
                checked="[[!_itemData.no_cost_causer]]"
                data-path="_itemData.no_cost_causer"
                on-change="toggleProperty"
              ></paper-checkbox>
            </paper-cell>
          </paper-row>

          <!-- Header Color -->
          <paper-row checkbox pointer>
            <paper-cell icon>
              <katapult-icon icon="format_color_fill"></katapult-icon>
            </paper-cell>
            <paper-cell shrink>Header Color</paper-cell>
            <paper-cell icon>
              <katapult-color-picker-button
                color="[[ahex2Rgba(_itemData.header_color)]]"
                data-path="_itemData.header_color"
                on-change="updateColor"
              ></katapult-color-picker-button>
            </paper-cell>
          </paper-row>

          <!-- No Cover Sheet -->
          <paper-row>
            <paper-cell icon>
              <katapult-icon icon="description"></katapult-icon>
            </paper-cell>
            <paper-cell shrink>Include Cover Sheet</paper-cell>
            <paper-cell icon>
              <paper-checkbox
                checked="[[!_itemData.no_cover_sheet]]"
                data-path="_itemData.no_cover_sheet"
                on-change="toggleProperty"
              ></paper-checkbox>
            </paper-cell>
          </paper-row>

          <iron-collapse opened="[[!_itemData.no_cover_sheet]]">
            <!-- Timeline Label -->
            <paper-row>
              <paper-cell icon>
                <katapult-icon icon="label"></katapult-icon>
              </paper-cell>
              <paper-cell shrink>Timeline Label</paper-cell>
              <paper-cell>
                <paper-input
                  label="Timeline Label"
                  no-label-float
                  value="[[_itemData.cover_sheet_text.timeline_label]]"
                  data-path="_itemData.cover_sheet_text.timeline_label"
                  on-change="updateProperty"
                ></paper-input>
              </paper-cell>
              <paper-cell></paper-cell>
            </paper-row>

            <!-- Timeline Options -->
            <paper-row expand>
              <paper-cell icon>
                <katapult-icon icon="view_timeline"></katapult-icon>
              </paper-cell>
              <paper-cell shrink>Timeline Options</paper-cell>
              <paper-cell>
                <paper-table rounded outline white dividers overflow-hidden grow>
                  <paper-table-scroll
                    data-path="_itemData.cover_sheet_text.timeline_options"
                    on-sort-changed="orderedItemsArraySortChanged"
                  >
                    <!-- Body -->
                    <template is="dom-repeat" items="[[getOrderedItemsArray(_itemData.cover_sheet_text.timeline_options)]]" mutable-data>
                      <paper-row slot="sortable" white>
                        <paper-cell icon drag-handle>[[add(index, 1)]]</paper-cell>
                        <paper-cell>
                          <paper-input
                            label="Timeline"
                            value="[[item.timeline]]"
                            data-path="_itemData.cover_sheet_text.timeline_options.$(model.item.$key).timeline"
                            no-label-float
                            on-change="updateProperty"
                          ></paper-input>
                        </paper-cell>
                        <paper-cell icon-button>
                          <katapult-button
                            iconOnly
                            noBorder
                            icon="delete"
                            data-path="_itemData.cover_sheet_text.timeline_options.$(model.item.$key)"
                            data-value="$null"
                            on-click="updateProperty"
                          ></katapult-button>
                        </paper-cell>
                      </paper-row>
                    </template>
                    <!-- Add Button -->
                    <paper-row
                      slot="after"
                      class="addButton"
                      ripple
                      light-grey
                      short
                      data-path="_itemData.cover_sheet_text.timeline_options"
                      on-click="addOrderedItem"
                    >
                      <paper-cell icon>
                        <katapult-icon icon="playlist_add"></katapult-icon>
                      </paper-cell>
                      <paper-cell justify-center>
                        <div>Add a Timeline Option</div>
                      </paper-cell>
                    </paper-row>
                  </paper-table-scroll>
                </paper-table>
              </paper-cell>
            </paper-row>

            <!-- Com Due Date -->
            <paper-row expand>
              <paper-cell icon>
                <katapult-icon icon="call"></katapult-icon>
              </paper-cell>
              <paper-cell shrink>Com Due Date</paper-cell>
              <paper-cell>
                <paper-table rounded outline white dividers overflow-hidden grow>
                  <!-- Body -->
                  <paper-row light-grey short>
                    <paper-cell>
                      <div>Timeline</div>
                      <!-- <katapult-button iconOnly icon="help_outline" fill=false noBorder></katapult-button> -->
                    </paper-cell>
                    <paper-cell>Label</paper-cell>
                    <paper-cell>Value</paper-cell>
                  </paper-row>
                  <template is="dom-repeat" items="[[getOrderedItemsArray(_itemData.cover_sheet_text.timeline_options)]]" mutable-data>
                    <paper-row expand>
                      <paper-cell style="opacity: 0.8;">[[item.timeline]]</paper-cell>
                      <paper-cell>
                        <paper-input
                          label="Label"
                          value="[[item.com_due_date_label]]"
                          data-path="_itemData.cover_sheet_text.timeline_options.$(model.item.$key).com_due_date_label"
                          no-label-float
                          on-change="updateProperty"
                        ></paper-input>
                      </paper-cell>
                      <paper-cell>
                        <paper-input
                          label="Value"
                          value="[[item.com_due_date_value]]"
                          data-path="_itemData.cover_sheet_text.timeline_options.$(model.item.$key).com_due_date_value"
                          no-label-float
                          on-change="updateProperty"
                        ></paper-input>
                      </paper-cell>
                    </paper-row>
                  </template>
                </paper-table>
              </paper-cell>
            </paper-row>

            <!-- Power Due Date -->
            <paper-row expand>
              <paper-cell icon>
                <katapult-icon icon="bolt"></katapult-icon>
              </paper-cell>
              <paper-cell shrink>Power Due Date</paper-cell>
              <paper-cell>
                <paper-table rounded outline white dividers overflow-hidden grow>
                  <!-- Body -->
                  <paper-row light-grey short>
                    <paper-cell>
                      <div>Timeline</div>
                    </paper-cell>
                    <paper-cell>Label</paper-cell>
                    <paper-cell>Value</paper-cell>
                  </paper-row>
                  <template is="dom-repeat" items="[[getOrderedItemsArray(_itemData.cover_sheet_text.timeline_options)]]" mutable-data>
                    <paper-row expand>
                      <paper-cell style="opacity: 0.8;">[[item.timeline]]</paper-cell>
                      <paper-cell>
                        <paper-input
                          label="Label"
                          value="[[item.power_due_date_label]]"
                          data-path="_itemData.cover_sheet_text.timeline_options.$(model.item.$key).power_due_date_label"
                          no-label-float
                          on-change="updateProperty"
                        ></paper-input>
                      </paper-cell>
                      <paper-cell>
                        <paper-input
                          label="Value"
                          value="[[item.power_due_date_value]]"
                          data-path="_itemData.cover_sheet_text.timeline_options.$(model.item.$key).power_due_date_value"
                          no-label-float
                          on-change="updateProperty"
                        ></paper-input>
                      </paper-cell>
                    </paper-row>
                  </template>
                </paper-table>
              </paper-cell>
            </paper-row>

            <!-- Self Help Warning -->
            <paper-row expand>
              <paper-cell icon>
                <katapult-icon icon="warning"></katapult-icon>
              </paper-cell>
              <paper-cell shrink>Self Help Warning</paper-cell>
              <paper-cell>
                <paper-textarea
                  label="Self Help Warning"
                  no-label-float
                  value="[[_itemData.cover_sheet_text.self_help_warning]]"
                  data-path="_itemData.cover_sheet_text.self_help_warning"
                  on-change="updateProperty"
                ></paper-textarea>
              </paper-cell>
            </paper-row>

            <!-- Cover Sheet Attributes -->
            <paper-row expand>
              <paper-cell icon>
                <katapult-icon icon="format_list_bulleted"></katapult-icon>
              </paper-cell>
              <paper-cell shrink>Cover Sheet Attributes</paper-cell>
              <paper-cell>
                <paper-table rounded outline white dividers overflow-hidden grow>
                  <paper-table-scroll data-path="_itemData.cover_sheet_attributes" on-sort-changed="orderedItemsArraySortChanged">
                    <paper-row slot="before" short light-grey>
                      <paper-cell icon></paper-cell>
                      <paper-cell>Type</paper-cell>
                      <paper-cell>Label</paper-cell>
                      <paper-cell>Value</paper-cell>
                      <paper-cell></paper-cell>
                      <paper-cell icon></paper-cell>
                    </paper-row>
                    <!-- Body -->
                    <template is="dom-repeat" items="[[getOrderedItemsArray(_itemData.cover_sheet_attributes)]]" mutable-data>
                      <paper-row slot="sortable" white>
                        <paper-cell icon drag-handle>[[add(index, 1)]]</paper-cell>
                        <paper-cell>
                          <katapult-drop-down
                            label="Attribute Type"
                            items="[[coverSheetAttributeTypes]]"
                            value-path="value"
                            label-path="label"
                            no-label-float
                            value="[[item.attribute_type]]"
                            data-path="_itemData.cover_sheet_attributes.$(model.item.$key).attribute_type"
                            on-selected-changed="updateProperty"
                          ></katapult-drop-down>
                        </paper-cell>
                        <paper-cell>
                          <paper-input
                            label="Label"
                            no-label-float
                            value="[[item.label]]"
                            data-path="_itemData.cover_sheet_attributes.$(model.item.$key).label"
                            on-change="updateProperty"
                          ></paper-input>
                        </paper-cell>
                        <paper-cell>
                          <katapult-drop-down
                            label="Value"
                            items="[[getCoverSheetAttributeValues(item.attribute_type, otherAttributes)]]"
                            value-path="value"
                            label-path="label"
                            no-label-float
                            value="[[item.value]]"
                            data-path="_itemData.cover_sheet_attributes.$(model.item.$key).value"
                            on-selected-changed="updateProperty"
                          ></katapult-drop-down>
                        </paper-cell>
                        <paper-cell>
                          <template is="dom-if" if="[[equal(item.attribute_type, 'node')]]">
                            <katapult-switcher
                              items="[[nodeValueTypes]]"
                              value-path="value"
                              label-path="label"
                              value="[[item.node_results]]"
                              data-path="_itemData.cover_sheet_attributes.$(model.item.$key).node_results"
                              on-selected-changed="updateProperty"
                            ></katapult-switcher>
                          </template>
                        </paper-cell>
                        <paper-cell icon-button>
                          <katapult-button
                            iconOnly
                            noBorder
                            icon="delete"
                            data-path="_itemData.cover_sheet_attributes.$(model.item.$key)"
                            data-value="$null"
                            on-click="updateProperty"
                          ></katapult-button>
                        </paper-cell>
                      </paper-row>
                    </template>
                    <!-- Add Button -->
                    <paper-row
                      slot="after"
                      class="addButton"
                      ripple
                      light-grey
                      short
                      data-path="_itemData.cover_sheet_attributes"
                      on-click="addOrderedItem"
                    >
                      <paper-cell icon>
                        <katapult-icon icon="playlist_add"></katapult-icon>
                      </paper-cell>
                      <paper-cell justify-center>
                        <div>Add Cover Sheet Attribute</div>
                      </paper-cell>
                    </paper-row>
                  </paper-table-scroll>
                </paper-table>
              </paper-cell>
            </paper-row>

            <!-- Logo -->
            <paper-row>
              <paper-cell icon>
                <katapult-icon icon="image"></katapult-icon>
              </paper-cell>
              <paper-cell shrink>Logo</paper-cell>
              <paper-cell>
                <katapult-drop-down
                  label="Logo"
                  items="[[getLogos(files)]]"
                  value-path="$key"
                  label-path="name"
                  no-label-float
                  value="[[_itemData.logo_file_key]]"
                  data-path="_itemData.logo_file_key"
                  on-selected-changed="updateProperty"
                ></katapult-drop-down>
              </paper-cell>
            </paper-row>

            <!-- Logo Address -->
            <paper-row>
              <paper-cell icon>
                <katapult-icon icon="contact_mail"></katapult-icon>
              </paper-cell>
              <paper-cell shrink>Logo Address</paper-cell>
              <paper-cell>
                <paper-input
                  label="Logo Address"
                  no-label-float
                  value="[[_itemData.logo_address]]"
                  data-path="_itemData.logo_address"
                  on-change="updateProperty"
                ></paper-input>
              </paper-cell>
              <paper-cell></paper-cell>
            </paper-row>
          </iron-collapse>

          <!-- Timeline Label -->
          <paper-row>
            <paper-cell icon>
              <katapult-icon icon="label"></katapult-icon>
            </paper-cell>
            <paper-cell shrink>Simple Make Ready Column Header</paper-cell>
            <paper-cell>
              <paper-input
                label="Simple Make Ready"
                no-label-float
                value="[[_itemData.simple_column_header]]"
                data-path="_itemData.simple_column_header"
                on-change="updateProperty"
              ></paper-input>
            </paper-cell>
            <paper-cell></paper-cell>
          </paper-row>
        </paper-table>
      `;
    }

    static get properties() {
      return {
        coverSheetAttributeTypes: {
          type: Array,
          value: () => [
            { value: 'special', label: 'Special Attribute' },
            { value: 'metadata', label: 'Metadata Attribute' },
            { value: 'node', label: 'Node Attribute' }
          ]
        },
        nodeValueTypes: {
          type: Array,
          value: () => [
            { value: 'first', label: 'First Result' },
            { value: 'join', label: 'Join Results' }
          ]
        }
      };
    }

    ifElse(x, a, b) {
      return x ? a : b;
    }

    ahex2Hexa(color) {
      if (!color) return;
      if (color.startsWith('#')) color = color.slice(1);
      const a = color.slice(0, 2);
      const hex = color.slice(2);
      console.log('the color is', `#${hex}${a}`);
      return `#${hex}${a}`;
    }

    ahex2Rgba(color) {
      const hexa = this.ahex2Hexa(color);
      if (!hexa) return;
      const rgba = ColorTranslator.toRGBA(hexa, { legacyCSS: true });
      return rgba;
    }

    getCoverSheetAttributeValues(type, attributes) {
      if (!attributes) return;
      switch (type) {
        case 'special':
          return [
            { value: '$attacherName', label: 'Attacher Name' },
            { value: '$mapLink', label: 'Map Link' }
          ];
        case 'metadata':
          return Object.entries(attributes)
            .filter(([key, value]) => value.attribute_types?.includes('job'))
            .map(([key]) => ({ value: key, label: CamelCase(key) }));
        case 'node':
          return Object.entries(attributes)
            .filter(([key, value]) => value.attribute_types?.includes('node'))
            .map(([key]) => ({ value: key, label: CamelCase(key) }));
      }
    }

    getLogos(files) {
      return Object.entries(files ?? {})
        .map(([$key, file]) => ({ ...file, $key }))
        .filter((file) => file.type?.startsWith('image'));
    }

    hexa2Ahex(color) {
      if (!color) return;
      if (color.startsWith('#')) color = color.slice(1);
      const hex = color.slice(0, 6);
      const a = color.slice(6);
      return `${a}${hex}`;
    }

    updateColor(e) {
      const trans = new ColorTranslator(e.detail.color);
      e.detail.value = this.hexa2Ahex(trans.HEXA);
      this.updateProperty(e);
    }

    updateProperty(e) {
      // Change events don't set a value on the event detail, and as of the time of writing, KatapultElement.updateProperty expects a value on the event detail for a 'change' type event.
      if (e.type == 'change' && e.currentTarget.tagName == 'PAPER-INPUT') e.detail.value = e.currentTarget.value;
      super.updateProperty(e);
    }
  }
);
